import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Paginator } from '../models/paginator';
import { Project, ProjectListFilter, ProjectStatus } from '../models/project';
import { Response, URLSearchParams } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

export class ListProjectOptions {
  query: string;
  page: number = 1;
  sortBy: string;
  filters: ProjectListFilter = new ProjectListFilter();

  toParams() {
    let params: URLSearchParams = new URLSearchParams();
    if (this.filters.searchString) {
      params.set('query', this.filters.searchString);
    }

    if (this.filters.client) {
      params.set('client', '' + this.filters.client);
    }

    if (this.filters.statuses && this.filters.statuses.length) {
      params.set('status', this.filters.statuses.join(','));
    }

    if (this.sortBy) {
      params.set('sort', this.sortBy);
    }

    params.set('page', this.page.toString());
    return params;
  }

}

@Injectable()
export class ProjectService {
  constructor(private http: HttpClient) {
  }

  get(options?: ListProjectOptions): Observable<Paginator<Project>> {
    return this.http.get<any>(`${environment.apiUrl}/projects`)
      .pipe(
        map(json => {
          let projects = json.data.map(row => {
            return new Project(row);
          });
          return new Paginator<Project>(json.meta.pagination, projects);
        }));
  }

  getLatest(): Observable<Project[]> {
    return this.http.get<any>(`${environment.apiUrl}/projects/latest`)
      .pipe(map(json => {
        return json.data.map(r => {
          return new Project(r);
        })
      }));
  }

  getProject(id: number): Observable<Project> {
    return this.http.get<any>(`${environment.apiUrl}/projects/${id}`)
      .pipe(map(json => {
        return new Project(json);
      }));
  }

  getProjectTreeForClient(clientId: number): Observable<Project[]> {
    return this.http.get<any>(`${environment.apiUrl}/clients/${clientId}/projects-tree`)
      .pipe(map(json => {
        return json.data.map((item) => {
          return new Project(item);
        });
      }));
  }

  toFlatArray(projects: Project[], prefix: string = ''): any[] {
    let values = [];
    projects.forEach(project => {
      values.push({
        id: project.id,
        name: prefix + project.name
      });
      if (project.children.length) {
        values = values.concat(this.toFlatArray(project.children, prefix + "--> "));
      }
    });
    return values;
  }

  destroy(project: Project): Observable<Object> {
    return this.http.delete(`${project.url}`);
  }

  destroyMany(projects: Project[]) {
    const ids = projects.map(p => p.id);
    const body = JSON.stringify({ id: ids });

    return this.http.post(`${environment.apiUrl}/projects/delete`, body);
  }

  sync(project: Project): Observable<Response> {
    return this.http.post<any>(`${project.url}/sync`, '')
    //.map(response => response.json());
  }

  update(project: Project): Observable<Project> {
    let data = project.toJson();
    let body = JSON.stringify(data);

    return this.http.put(`${project.url}`, body)
      .pipe(map(json => {
        return new Project(json);
      }));
  }

  updateStatusMany(projects: Project[], status: ProjectStatus): Observable<boolean> {
    const ids = projects.map(p => p.id);
    const body = JSON.stringify({ id: ids, status: status });
    return this.http.post(`${environment.apiUrl}/projects/set-status`, body)
      .pipe(map(json => {
        return true;
      }));
  }

  create(clientId: number, project: Project, parentId?: number): Observable<Project> {
    let data = project.toJson();
    if (parentId) {
      data.parent_id = parentId;
    }
    let body = JSON.stringify(data);

    return this.http.post(`${environment.apiUrl}/clients/${clientId}/projects`, body)
      .pipe(map(json => {
        return new Project(json);
      }));
  }

  move(project: Project, to: Project): Observable<Project> {
    let body = JSON.stringify({ to: to ? to.id : null });
    return this.http.post(`${project.url}/move`, body)
      .pipe(map(json => {
        return new Project(json);
      }));
  }

  getProjectTree(id: number): Observable<Project> {
    return this.http.get<any>(`${environment.apiUrl}/projects/${id}/tree`)
      .pipe(map(json => {
        return new Project(json.data[0]);
      }));
  }

  getPublic(id: number) {
    return this.http.get<any>(`${environment.apiUrl}/public/projects/${id}`)
      .pipe(map(json => {
        return json;
      }));
  }
}



// WEBPACK FOOTER //
// ./src/app/projects/project.service.ts